import React from "react";
import selectFormat from "../selectFormat";
import metricDefinitions from "../../metricDefinitions";
import { useSelector } from "react-redux";

export default function MedicinalMarijuana(props) {
    const { organization_name, permissions } = useSelector(
        (state) => state.static
    );
    const { hiddenOutcomes } = useSelector((state) => state.settings);
    let metrics = metricDefinitions(organization_name, permissions)[
        "medicinal marijuana"
        ].metrics;

    return (
        <div className="col-12">
            {metrics
                .filter((metric) => metric.visible == true)
                .filter((metric) => !hiddenOutcomes.includes(metric.outcome_slug))
                .map((metric, index) => {
                    return selectFormat(metric, index, props);
                })}
            <div className="py-3" />
        </div>
    );
}
